import React from 'react';
import styled from 'styled-components';
import { blueColor, lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.65 22.25" {...rest}>
    <polygon className="check-mark" points="10.95 22.25 0 11.3 3.56 7.74 10.95 15.14 26.09 0 29.65 3.56 10.95 22.25" />
  </svg>
))`
  position: relative;
  top: -1px;

  .check-mark {
    fill: ${({ color, disabled }) => (color ? color : disabled ? lightGrey2Color : blueColor)};
  }
`;
